import axios from "axios";
import { baseUrl, azilisSwitchToBool } from "../util";

// Flow 37.1 - Material Usage
export const getAllMaterialUsage37_1LCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/installation-material-usage-37-1-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching material usage 37.1:", error);
      setObjects([]);
    });
};

export const addMaterialUsage37_1LCA = ({
  productId,
  own_name,
  material,
  qty,
  scenario,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/installation-material-usage-37-1-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      own_name: own_name || null,
      material: material,
      qty: qty || 0,
      scenario: scenario || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding material usage 37.1:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add material usage",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateMaterialUsage37_1LCA = ({
  productId,
  rowId,
  own_name,
  material,
  qty,
  scenario,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/installation-material-usage-37-1-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      own_name: own_name || null,
      material: material,
      qty: qty || 0,
      scenario: scenario || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating material usage 37.1:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update material usage",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteMaterialUsage37_1LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/installation-material-usage-37-1-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting material usage 37.1:", error);
    });
};

// Flow 37.2 - Surplus Resources
export const getAllSurplusResources37_2LCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/installation-surplus-resources-37-2-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching surplus resources 37.2:", error);
      setObjects([]);
    });
};

export const addSurplusResources37_2LCA = ({
  productId,
  surplus_resource,
  disposal_method,
  qty,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/installation-surplus-resources-37-2-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      surplus_resource: surplus_resource || null,
      disposal_method: disposal_method,
      qty: qty || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding surplus resources 37.2:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add surplus resource",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateSurplusResources37_2LCA = ({
  productId,
  rowId,
  surplus_resource,
  disposal_method,
  qty,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/installation-surplus-resources-37-2-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      surplus_resource: surplus_resource || null,
      disposal_method: disposal_method,
      qty: qty || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating surplus resources 37.2:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update surplus resource",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteSurplusResources37_2LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/installation-surplus-resources-37-2-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting surplus resources 37.2:", error);
    });
};

// Flow 37.3 - By-products
export const getAllByProducts37_3LCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/installation-by-products-37-3-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching by-products 37.3:", error);
      setObjects([]);
    });
};

export const addByProducts37_3LCA = ({
  productId,
  surplus_resource,
  qty,
  by_product_sold,
  by_product_used_in_this_product,
  by_product_used_in_another_product,
  monetary_value,
  currency,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/installation-by-products-37-3-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      surplus_resource: surplus_resource,
      qty: qty || 0,
      by_product_sold: azilisSwitchToBool(by_product_sold),
      by_product_used_in_this_product: azilisSwitchToBool(
        by_product_used_in_this_product
      ),
      by_product_used_in_another_product: azilisSwitchToBool(
        by_product_used_in_another_product
      ),
      monetary_value: monetary_value || null,
      currency: currency || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding by-products 37.3:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add by-product",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateByProducts37_3LCA = ({
  productId,
  rowId,
  surplus_resource,
  qty,
  by_product_sold,
  by_product_used_in_this_product,
  by_product_used_in_another_product,
  monetary_value,
  currency,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/installation-by-products-37-3-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      surplus_resource: surplus_resource,
      qty: qty || 0,
      by_product_sold: azilisSwitchToBool(by_product_sold),
      by_product_used_in_this_product: azilisSwitchToBool(
        by_product_used_in_this_product
      ),
      by_product_used_in_another_product: azilisSwitchToBool(
        by_product_used_in_another_product
      ),
      monetary_value: monetary_value || null,
      currency: currency || null,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating by-products 37.3:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update by-product",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteByProducts37_3LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/installation-by-products-37-3-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting by-products 37.3:", error);
    });
};

// Flow 37.4 - Losses
export const getAllLosses37_4LCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/installation-losses-37-4-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching losses 37.4:", error);
      setObjects([]);
    });
};

export const addLosses37_4LCA = ({
  productId,
  own_name,
  material,
  amount,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/installation-losses-37-4-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      own_name: own_name || null,
      material: material,
      amount: amount || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding losses 37.4:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add loss",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateLosses37_4LCA = ({
  productId,
  rowId,
  own_name,
  material,
  amount,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/installation-losses-37-4-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      own_name: own_name || null,
      material: material,
      amount: amount || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating losses 37.4:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update loss",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteLosses37_4LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/installation-losses-37-4-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting losses 37.4:", error);
    });
};

// Flow 37: Get Total Impact for Installation and Construction
export const getInstallationConstruction37Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/installation-construction-37-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching installation construction 37 totals:", error);
      setTotals(null);
    });
};

